'use client';

import { useMemo, useState } from 'react';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../../ui/card';
import { Button } from '../../../ui/button';
import { CHART_COLORS, ChatChartData } from './ChatChartComponent';
import ChatChartTablePreview from './ChatChartTablePreview';

interface PieChartProps {
    chartData: ChatChartData;
}

export const ChatPieChartComponent = ({ chartData }: PieChartProps) => {
    const [showMetadata, setShowMetadata] = useState(false);
    const { meta, data } = chartData;



    const { name_key, value_key } = useMemo(() => {
        return {
            name_key: meta?.nameKey ?? meta?.name_key ?? "",
            value_key: meta?.valueKey ?? meta?.value_key ?? ""
        };

    }, [chartData])


    if (!name_key || !value_key) {
        return <div>Missing configuration for PieChart</div>;
    }

    // const nameKey = meta.nameKey

    return (
        <Card className="w-full shadow-md hover:shadow-lg transition-shadow duration-300">
            <CardHeader className="flex flex-row items-center justify-between">
                <div>
                    <CardTitle>Pie Chart</CardTitle>
                    <CardDescription>Distribution by {value_key}</CardDescription>
                </div>
                <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => setShowMetadata(!showMetadata)}
                    aria-label={showMetadata ? 'Hide data table' : 'Show data table'}
                >
                    {showMetadata ? <ChevronUp className="h-5 w-5" /> : <ChevronDown className="h-5 w-5" />}
                </Button>
            </CardHeader>
            <CardContent>
                <div className="min-h-[600px] w-full">
                    <ResponsiveContainer width="100%" height={600}>
                        <PieChart>
                            <Pie
                                data={data}
                                cx="50%"
                                cy="50%"
                                labelLine={true}
                                label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
                                outerRadius={80}
                                fill="#8884d8"
                                dataKey={value_key}
                                nameKey={name_key}
                            >
                                {data.map((entry: any, index: number) => (
                                    <Cell key={`cell-${index}`} fill={CHART_COLORS[index % CHART_COLORS.length]} />
                                ))}
                            </Pie>
                            <Tooltip formatter={(value) => [`${value}`, value_key]} />
                            <Legend />
                        </PieChart>
                    </ResponsiveContainer>
                </div>

                <ChatChartTablePreview closeTable={() => {
                    setShowMetadata(false);
                }} showTable={showMetadata} data={data} />
            </CardContent>
        </Card>
    );
};

